import { Button } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Campaign } from '../../campaign'
import { CampaignFacebookAccountSelect } from '../../../facebook/components/campaign-facebook-account-select'
import { CampaignLeadgenFormSelect } from '../../../facebook/components/campaign-leadgen-form-select'
import { ConnectionCard } from '../../../facebook/components/connection-card'
import { SetupCheckResults } from '../../../facebook/components/setup-check-results'
import { SetupCheckResult } from '../../../facebook/setup-check'
import { FormItem } from '../../../components/form-item'

type CampaignLeadFormSectionProps = {
    campaignId: Campaign['id']
    facebookConnected?: boolean
    accountId?: string | null
    leadSetupResult: SetupCheckResult | null
    isCheckingLeadSetup: boolean
    onAccountClear: () => void
    onValidateLeadSetup: () => void
}

export function CampaignLeadFormSection({
    campaignId,
    facebookConnected,
    accountId,
    leadSetupResult,
    isCheckingLeadSetup,
    onAccountClear,
    onValidateLeadSetup,
}: CampaignLeadFormSectionProps) {
    const { t } = useTranslation()

    return (
        <>
            {facebookConnected ? (
                <div className="w-full">
                    <FormItem
                        label={t('Select the Facebook Page where your lead form is active')}
                        name="accountId"
                    >
                        <CampaignFacebookAccountSelect
                            campaignId={campaignId}
                            onClear={onAccountClear}
                        />
                    </FormItem>

                    {accountId && (
                        <>
                            <FormItem
                                label={t('Now, choose the lead form you want to connect')}
                                name="formId"
                            >
                                <CampaignLeadgenFormSelect
                                    campaignId={campaignId}
                                    accountId={accountId ?? undefined}
                                />
                            </FormItem>

                            <Button
                                loading={isCheckingLeadSetup}
                                onClick={onValidateLeadSetup}
                            >
                                {t('Validate lead setup')}
                            </Button>
                        </>
                    )}

                    {leadSetupResult && (
                        <SetupCheckResults
                            className="my-4"
                            result={leadSetupResult}
                            successMessage={t('Lead setup is ready')}
                            warningMessage={t('Lead setup needs attention')}
                        />
                    )}
                </div>
            ) : (
                <ConnectionCard className="mb-4" />
            )}
        </>
    )
}
